var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1591 76.1601C81.5591 76.7601 80.7991 77.0401 80.0391 77.0401C79.2791 77.0401 78.5191 76.7601 77.9191 76.1601L58.1191 56.3601L60.2391 54.2401L62.3591 52.1201L82.1591 71.9201C83.3191 73.0801 83.3191 75.0001 82.1591 76.1601Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.8795 37.1199L49.0796 60.3199C50.6396 61.8799 50.6396 64.3999 49.0796 65.9599L45.4795 69.5998C42.2395 72.7998 37.1195 72.7998 33.9195 69.5998L16.5595 52.2399C13.3995 49.0799 13.3995 43.9198 16.5595 40.7198L20.1996 37.0799C21.7596 35.5599 24.3195 35.5599 25.8795 37.1199Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.36 40.76L59.12 55.96C57.52 57.56 54.96 57.56 53.36 55.96L30.2801 32.88C28.6801 31.28 28.6801 28.72 30.2801 27.12L45.5201 11.88C48.6801 8.72001 53.84 8.72001 57.04 11.88L74.4001 29.24C77.5201 32.4 77.52 37.52 74.36 40.76Z",
    fill: "#F2654E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 87H8C6.36 87 5 85.64 5 84C5 82.36 6.36 81 8 81H32C33.64 81 35 82.36 35 84C35 85.64 33.64 87 32 87Z",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.345e82bbd5bc335248cc91dab0462c99.svg";
export { ForwardRef as ReactComponent };